import { useEffect } from 'react';

interface PageMetaProps {
  title: string;
  description?: string;
  canonical?: string;
}

export default function PageMeta({ title, description, canonical }: PageMetaProps) {
  useEffect(() => {
    document.title = title;

    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);
    }

    if (canonical) {
      let linkCanon = document.querySelector('link[rel="canonical"]');
      if (!linkCanon) {
        linkCanon = document.createElement('link');
        linkCanon.setAttribute('rel', 'canonical');
        document.head.appendChild(linkCanon);
      }
      linkCanon.setAttribute('href', canonical);
    }
  }, [title, description, canonical]);

  return null;
}